





































































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { isUndefined } from 'lodash/fp'
import KYCForm from '@company-common/model/kyc-form/KYCForm'
import AppDatatable from '@core/components/AppDatatable.vue'
import AppForm from '@core/components/AppForm.vue'
import { FormStructure } from '@master/model/structure/FormStructure'
import PersonalDetails from '@master/model/kyc-form/PersonalDetails'
import ClientDeclaration from '@master/model/kyc-form/ClientDeclaration'
import TheMyInfoView from '@core/pages/myinfo/TheMyInfoView.vue'
import AppRadioSelection from '@core/components/AppRadioSelection.vue'
import { inject } from 'inversify-props'
import { IDateService } from '@master/services/IDateService'
import API from '@core/services/API'
import AppDialog from '@core/components/AppDialog.vue'
import AppNewClientSingpass from '@core/components/AppNewClientSingpass.vue'

const kycFormStore = namespace('KYCFormStore')

interface PdfHistory {
  _oid: string;
  adviser_name: string;
  supervisor_fullname: string;
  date_pdf_submission: string;
  date_supervisor_decide: string;
  date_ops_decide: string;
  pdf_status: string;
  consolidatedStatus: string;
  adviser_finalised: string | boolean;
  redirect: string;
  keyword: string;
}
@Component({
  components: {
    AppDatatable,
    AppForm,
    TheMyInfoView,
    AppRadioSelection,
    AppDialog,
    AppNewClientSingpass
  }
})
export default class ClientSummary extends Vue {
  @kycFormStore.State
  private kycForm!: KYCForm;

  @kycFormStore.State
  private myInfoStatus: {}

  @kycFormStore.Action
  private checkMyInfoUpdate!: (formOid: string) => void

  @kycFormStore.Action
  public loadKYCForm!: (formOid: string) => void

  @kycFormStore.State
  private computedValidationResult

  infoUpdateInterval
  infoUpdateTimeout

  private loadingpdfHistory = true;
  private pdfHistoryColumns: Array<object> = [
    { label: 'Adviser Name', field: 'adviser_name' },
    { label: 'Assigned Supervisor', field: 'supervisor_fullname' },
    { label: 'Date of Submission', field: 'date_pdf_submission' },
    { label: 'Date of A/R (Sup)', field: 'date_supervisor_decide' },
    { label: 'Date of A/R (Ops)', field: 'date_ops_decide' },
    { label: 'PDF Status', field: 'pdf_status' },
    { label: 'E-Submission Status', field: 'consolidatedStatus' },
    { label: 'Adviser Finalised', field: 'adviser_finalised' }
  ];

  private pdfHistoryKeys = [
    '_oid',
    'adviser_name',
    'supervisor_fullname',
    'date_pdf_submission',
    'date_supervisor_decide',
    'date_ops_decide',
    'pdf_status',
    'consolidatedStatus',
    'adviser_finalised'
  ];

  private txtSearch = '';
  private pdfHistoryRows: PdfHistory[] = [];

  private showMyInfoView = false
  private showMyInfoRequestDialog = false
  private kycFormOid = ''
  private linkPersonParam = {}
  private clientTag

  @inject()
  private dateService: IDateService

  @inject()
  private $api: API

  isLockedField (key, clientIndex) {
    const index = clientIndex + 1 // because in kycform, it is client1, client2

    if (isUndefined(this.kycForm['client' + index].myInfo.lockedFields)) {
      return
    }

    return this.kycForm['client' + index].myInfo.keyIsLockedField(key)
  }

  getPersonalDetailStructure (clientIndex): FormStructure<PersonalDetails> {
    return [
      {
        label: 'Title',
        key: 'title',
        options: [
          { label: 'Dr', value: 'dr' },
          { label: 'Mr', value: 'mr' },
          { label: 'Mrs', value: 'mrs' },
          { label: 'Mdm', value: 'mdm' },
          { label: 'Miss', value: 'miss' }
        ],
        disabled: (personalDetails) => personalDetails.included !== true
      },
      {
        label: 'Name',
        key: 'name',
        disabled: (personalDetails) => personalDetails.included !== true || this.isLockedField('name', clientIndex),
        isMyInfo: this.isLockedField('name', clientIndex)
      },
      {
        label: 'NRIC/FIN/Passport No.',
        key: 'nric',
        disabled: (personalDetails) => personalDetails.included !== true || this.isLockedField('nric', clientIndex),
        isMyInfo: this.isLockedField('nric', clientIndex)
      },
      {
        label: 'Contact Mobile',
        key: 'contactMobile',
        disabled: (personalDetails) => personalDetails.included !== true || this.isLockedField('contactMobile', clientIndex),
        isMyInfo: this.isLockedField('contactMobile', clientIndex)
      }
    ]
  }

  get clientDeclarationStructure (): FormStructure<ClientDeclaration> {
    return [
      {
        label: 'Date of First Appointment',
        key: 'reviewDate',
        type: 'date'
      }
    ]
  }

  get client1PersonalDetails () {
    return this.kycForm.client1.personalDetails
  }

  get client2PersonalDetails () {
    return this.kycForm.client2.personalDetails
  }

  get clientDeclaration () {
    return this.kycForm.clientDeclaration
  }

  get client1IsLinked () {
    return this.kycForm.client1.myInfo.infoLinked
  }

  get client2IsLinked () {
    return this.kycForm.client2.myInfo.infoLinked
  }

  get sectionErrors () {
    return this.computedValidationResult['Client Summary'] || {}
  }

  get currentSection1ValidationErrors () {
    console.log(this.sectionErrors)
    const errors = this.sectionErrors['Client 1'] ? this.sectionErrors['Client 1'] : []
    const finalErrors: { key: string; msg: string }[] = []
    errors.map(({ key, message }) => {
      key.map(variableName => {
        finalErrors.push({
          key: variableName,
          msg: message
        })
      })
    })
    return finalErrors
  }

  get currentSection2ValidationErrors () {
    const errors = this.sectionErrors['Client 2'] ? this.sectionErrors['Client 2'] : []
    const finalErrors: { key: string; msg: string }[] = []
    errors.map(({ key, message }) => {
      key.map(variableName => {
        finalErrors.push({
          key: variableName,
          msg: message
        })
      })
    })
    return finalErrors
  }

  renameObjectKeys (list: Array<object>, keys: Array<string>): Array<object> {
    const newList = list.map(function (data) {
      const keyValues = Object.keys(data).map(function (key) {
        const newKey = keys[key]
        return { [newKey]: data[key] }
      })
      return Object.assign({}, ...keyValues)
    })
    return newList
  }

  mounted () {
    this.kycFormOid = this.$route.params.formOid
    this.$api.kycPdf
      .list({
        query: 'kyc_id = ?',
        queryArgs: JSON.stringify([this.kycFormOid]),
        headers: JSON.stringify(this.pdfHistoryKeys)
      })
      .then((response) => {
        this.pdfHistoryRows = this.renameObjectKeys(
          response.data,
          this.pdfHistoryKeys
        ) as PdfHistory[]
        this.pdfHistoryRows.map((history) => {
          history.date_pdf_submission = this.dateService.format(history.date_pdf_submission, 'YYYY-MM-DD')
          history.date_supervisor_decide = history.date_supervisor_decide
            ? this.dateService.format(history.date_supervisor_decide, 'YYYY-MM-DD')
            : '-'
          history.date_ops_decide = history.date_ops_decide
            ? this.dateService.format(history.date_ops_decide, 'YYYY-MM-DD')
            : '-'
          if (history.pdf_status === 'adviser-confirmed') {
            history.pdf_status = 'Not Signed'
          } else if (
            history.pdf_status === 'adviser-signed' &&
            history.adviser_finalised
          ) {
            history.pdf_status = 'Not Finalised'
          } else if (
            history.pdf_status === 'adviser-signed' &&
            !history.adviser_finalised
          ) {
            history.pdf_status = 'Pending Supervisor'
          } else if (history.pdf_status === 'adviser-cancelled') {
            history.pdf_status = 'Adviser Cancelled'
          } else if (history.pdf_status === 'supervisor-approved') {
            history.pdf_status = 'Supervisor Approved'
          } else if (history.pdf_status === 'supervisor-rejected') {
            history.pdf_status = 'Supervisor Rejected'
          } else if (history.pdf_status === 'submission-accepted') {
            history.pdf_status = 'Submission Accepted'
          } else if (history.pdf_status === 'submission-rejected') {
            history.pdf_status = 'Submission Rejected'
          }
          if (history.consolidatedStatus === 'Pending') {
            history.consolidatedStatus = 'Not Submitted'
          } else if (history.consolidatedStatus === 'Completed') {
            history.consolidatedStatus = 'Submitted'
          }
          history.adviser_finalised = history.adviser_finalised ? 'Yes' : 'No'
          history.redirect = '/live/kyc-pdf/' + history._oid
          history.keyword = Object.values(history).join(',').toLowerCase()
          return history
        })
        this.loadingpdfHistory = false
      })
      .catch((error) => {
        console.error('ClientSummary.js: Exception', error)
        alert('ClientSummary.js' + error)
        this.loadingpdfHistory = false
      })

    this.startCheckMyInfoUpdate()
  }

  startCheckMyInfoUpdate () {
    this.checkMyInfoUpdate(this.kycFormOid)
    this.infoUpdateTimeout = setTimeout(this.startCheckMyInfoUpdate, 30000)
  }

  beforeDestroy () {
    clearTimeout(this.infoUpdateTimeout)
  }

  requestMyInfo (clientIndex: 0 | 1) {
    this.showMyInfoRequestDialog = true
    this.clientTag = clientIndex
  }

  async syncMyInfo (clientIndex: 0 | 1) {
    const params = {
      kycFormOid: this.kycFormOid,
      clientIndex: clientIndex,
      action: 'sync'
    }
    const { success, error } = await this.$api.myInfo.syncMyInfo(params)
    if (success) {
      alert('sync success')
      await this.loadKYCForm(this.kycFormOid)
    } else {
      console.log(error)
      alert(error)
    }
  }

  linkMyInfo (clientIndex: 0 | 1) {
    this.linkPersonParam = {
      kycFormOid: this.kycFormOid,
      clientIndex: clientIndex
    }
    this.showMyInfoView = true
  }

  async needLinkPersonInfo (result) {
    this.showMyInfoView = false
    if (result.shouldLinked) {
      const params = {
        kycFormOid: this.kycFormOid,
        clientIndex: result.clientIndex,
        lockedFields: result.lockedField,
        action: 'link'
      }
      const { success, error } = await this.$api.myInfo.linkPersonInfo(params)
      if (success) {
        alert('Link success')
        await this.loadKYCForm(this.kycFormOid)
      } else {
        console.log(error)
        alert(error)
      }
    }
  }

  async unlinkMyInfo (clientIndex: 0 | 1) {
    const params = {
      kycFormOid: this.kycFormOid,
      clientIndex: clientIndex,
      action: 'unlink'
    }
    const { success, error } = await this.$api.myInfo.unlinkPersonInfo(params)
    if (success) {
      alert('Unlink success')
      await this.loadKYCForm(this.kycFormOid)
    } else {
      console.log(error)
      alert(error)
    }
  }

  disabledMyInfoButton () {
    return !this.kycForm.hasClient2
  }
}
